import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FsInputDirective } from './fs-input.directive';

@NgModule({
  imports: [CommonModule, FsInputDirective],
  exports: [FsInputDirective],
})
export class FsInputModule {}
